import { forwardRef, useEffect, useRef, useState } from 'react';
import FilesGroupEdit from './FilesGroupEdit';
import BaseWebUniversal, { BaseWebUniversalProps } from '../system/BaseWebUniversal';
import { Select, Switch, Tooltip } from 'antd';
import getList from '../../universal/getList';
import { columnsheadId } from '../system/columnshead';
import fetchApi from '../system/fetchApi';
import { CommonProps } from '../../../utilsTs/declareTypes';
import { useMergedRef } from '../hooks/general';

export interface BaseFilesGroupProps extends Pick<BaseWebUniversalProps, 'defaultService' | 'displayOptions' | 'editOptions' | 'sendPageData'>,
    Pick<CommonProps, 'closeModal'> {
};

const WebComponent = forwardRef<any, BaseFilesGroupProps>((props, ref) => {
    const internalRef = useRef<any>(undefined);
    /** 合并外部 ref 和内部 refLocal */
    const mergedRef = useMergedRef(internalRef, ref);
    const apiId = 'filesGroup';
    const [filesServerData, setFilesServerData] = useState<any>();
    const [selectedServerId, setSelectedServerId] = useState<string | undefined>(undefined);
    const [serviceData, setServiceData] = useState<any>();
    const [selectedServiceId, setSelectedServiceId] = useState<string | undefined>(undefined);

    /**
     * 获取服务号数据
     * @param options 选项
     */
    const getServiceData = async (options: {
        /** 文件服务器id */
        filesServerId: string;
        /** 服务地址 */
        urlService?: string;
    }) => {
        const { filesServerId, urlService = internalRef.current.defaultService } = options;
        fetchApi.GET(urlService,
            {
                query: {
                    apiId: 'filesService',
                    apiExtend: 'showList',
                    apiData: {
                        sendPageData: {
                            filesServerId
                        }
                    }
                }
            }).then(res => {
                if (res.success) {
                    setServiceData(res.data);
                }
            })
    };

    useEffect(() => {
        fetchApi.GET(internalRef.current.defaultService,
            {
                query: {
                    apiId: 'filesServer',
                    apiExtend: 'showList'
                }
            }).then(res => {
                if (res.success) {
                    setFilesServerData(res.data);
                    for (const item of res.data) {
                        const { id, isDefault, defaultServiceId } = item;
                        if (isDefault === true) {
                            setSelectedServerId(id);
                            setSelectedServiceId(defaultServiceId);
                            getServiceData({
                                filesServerId: id,
                                urlService: internalRef.current.defaultService
                            });
                            break;
                        }
                    }
                }
            })
    }, []);
    /**
     * 表头内容
     */
    const columnsHead = [
        {
            title: '组名',
            dataIndex: 'groupName',
        },
        {
            title: "服务号",
            dataIndex: 'service',
            render: (text: any) => (
                text
                    ? text.serviceName
                    : ''
            )
        },
        {
            title: '文件夹',
            dataIndex: 'folder',
        },
        {
            title: '日期目录',
            dataIndex: 'isCreateDateDirectory',
            render: (text: any, record: any) => (
                <Tooltip placement="topLeft" title={"是否每天生成日期子目录存放文件，" +
                    "如[是]刚不能自定义子目录?，" +
                    "如[否]可上传自定义子目录(上传带参数subdirectory)。"}>
                    <Switch checkedChildren="是" unCheckedChildren="否"
                        checked={text} key={record.id}
                    /></Tooltip>)
        }
    ];

    /**
     * 表头
     */
    const columns = columnsheadId
        .concat(columnsHead as []);

    /**
     * 扩展Props
     */
    let extendProps: BaseWebUniversalProps = {
        ...props,
        titleName: '文件组',
        apiId,
        columns,
        displayOptions: {
            deleteButton: {
                useCheckBox: true,
                checkBoxContent: '删除无法恢复，小心删除！',
                isChecked: true
            }
        },
        editOptions: {
            Editor: FilesGroupEdit
        },
        renderHeadExtra: ({ rows, fetchData }) => (
            <>
                <Select
                    showSearch
                    placeholder="服务器"
                    optionFilterProp="children"
                    value={selectedServerId}
                    onChange={async (e, option: any) => {
                        await getServiceData({
                            filesServerId: e
                        })
                        setSelectedServerId(e);
                        const { defaultServiceId } = option?.item;
                        setSelectedServiceId(defaultServiceId);
                        fetchData({
                            sendPageData: {
                                filesServerId: e,
                                serviceId: defaultServiceId
                            }
                        });
                    }}
                    style={{ width: 130 }}
                    filterOption={(input, option: any) =>
                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                    {getList.general(filesServerData, {
                        itemName: 'serverName'
                    })}
                </Select>
                <Select
                    showSearch
                    placeholder="服务号"
                    optionFilterProp="children"
                    value={selectedServiceId}
                    onChange={(e) => {
                        setSelectedServiceId(e);
                        fetchData({
                            sendPageData: {
                                filesServerId: selectedServerId,
                                serviceId: e
                            }
                        });
                    }}
                    style={{ width: 130 }}
                    filterOption={(input, option: any) =>
                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                    {getList.general(serviceData, {
                        itemName: 'serviceName'
                    })}
                </Select>
            </>
        )
    };

    return (
        <>
            <BaseWebUniversal {...extendProps} ref={mergedRef} />
        </>
    )
});

export default WebComponent;